import { useState } from 'react';
import { Popover } from 'antd';
import Button from '../../../../shared/SmallComponents/Button';
import { styled } from '../../../../shared/Theme/theme';
import Tooltip from '@mui/material/Tooltip';
import ConsolidationsFilterContent from './ConsolidationsFilterContent';

type Props = {
    activeFiltersCount: number;
    localization: any;
    filterFields: import('../../../../../state/ducks/allShipmentsPage/allShipmentsPage').filterFieldsType;
    onApplyFilters: (filter: import('../../../../../state/ducks/allShipmentsPage/allShipmentsPage').filterFieldsType) => void;
};

const ConsolidationsFilterPopover = ({ activeFiltersCount, localization, filterFields, onApplyFilters }: Props) => {
    const [visible, setVisible] = useState(false);

    return (
        <Popover
            overlayClassName="custom-popover"
            placement="bottomRight"
            align={{ offset: [-5, -5] }}
            content={
                <ConsolidationsFilterContent
                    filterFields={filterFields}
                    onCancel={() => setVisible(false)}
                    onApplyFilters={onApplyFilters}
                />
            }
            trigger="click"
            visible={visible}
            onVisibleChange={setVisible}
        >
            <ButtonContainer>
                <Button width="32px" height="32px" borderRadius="50%" margin="7px" buttonType="hollow">
                    <Tooltip title={localization?.filter_btn || 'Filter'} aria-label="filter">
                        <span className="material-icons-outlined">filter_alt</span>
                    </Tooltip>
                </Button>
                {activeFiltersCount > 0 && <Badge>{activeFiltersCount}</Badge>}
            </ButtonContainer>
        </Popover>
    );
};

const ButtonContainer = styled.div`
    position: relative;
`;

const Badge = styled.span`
    position: absolute;
    top: 3px;
    right: 0;
    background: ${(props) => props.theme.colors.primaryBlue};
    padding: 3px;
    height: 15px;
    width: 15px;
    border-radius: 50%;
    font-size: 10px;
    line-height: 9px;
    color: white;
    text-align: center;
`;

export default ConsolidationsFilterPopover;
